<h1 showdown [showDelay]="100">
  <!-- <span>About Us</span> <app-logo [size]="180"></app-logo> -->
  <span class="visually-hidden">About Lace &amp; Liora</span>
  <app-logo [size]="160"></app-logo>
</h1>

<h2 showdown [showDelay]="150">Romantic lace, made for everyday confidence.</h2>

<article>

  <h3 showdown [showDelay]="200">Our Story</h3>
  <p showdown [showDelay]="250">Founded in 2024, {{appname}} began with a love for lace and the quiet confidence it
    brings. We create romantic lace tops, dresses, and feminine separates for women who want softness, detail, and ease
    in everyday style.</p>
  <p showdown [showDelay]="300">Our team brings together experience in fabric selection, styling, operations, and
    customer experience, working every day to make lace feel modern, wearable, and beautifully personal.
  </p>
  <h3 showdown [showDelay]="350">Our Design Philosophy</h3>
  <p showdown [showDelay]="400">We design with lace at the center: soft handfeel, flattering silhouettes,
    thoughtful sheerness, and details that feel delicate without being difficult to wear.</p>
  <p showdown [showDelay]="450">Every piece is selected to layer easily, move comfortably, and bring a romantic
    touch from casual days to special plans.</p>

  <p showdown [showDelay]="500">
    Thank you for choosing <b>{{appname}}</b>, where lace meets everyday romance.
  </p>
</article>